import { SelectableLink, SelectableLinkContainer } from "components/Link";
import Modal from "components/Modal";
import Title from "components/Title";
import { doorOpens } from "core/constants/sound";
import { isEscapeKey } from "core/utils/keyDown";
import { getRandomItem } from "core/utils/logic";
import { processText } from "core/utils/string";
import { exit } from "core/utils/window";
import { useToggleModalWithSound } from "hooks/navigation";
import { usePlaySoundEffect } from "hooks/sound";
import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { getIsModalOpen } from "reducer/modalState";
import { SESSION_NAME, setOption } from "reducer/options";
import styled from "styled-components";
import { desktop } from "submodules/sharedText/flavor";

const { home, general } = desktop;
const flavor = { ...general, ...home };

const ButtonWrapper = styled.div`
  position: absolute;
  bottom: 0;
  margin-bottom: 2vh;
  width: 100%;
`;

const Container = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 2vh;
`;

const Home = () => {
  const dispatch = useDispatch();
  const showModal = useSelector(getIsModalOpen);
  const toggleModal = useToggleModalWithSound();
  const playSoundEffect = usePlaySoundEffect();

  const playEnter = () => playSoundEffect(getRandomItem(doorOpens));
  const onPressEscape = (e) => {
    if (isEscapeKey(e)) {
      return toggleModal();
    }
  };

  const handleExit = () => {
    // Clear the session name so a new one is generated on next launch
    dispatch(setOption(SESSION_NAME, ""));
    toggleModal();
    // For web version, just stay on home page (session is cleared)
    // For Electron version, this would close the app
    // Commenting out window close for now since we're in web mode
    // setTimeout(() => {
    //   exit();
    // }, 500);
  };

  return (
    <>
      <Container>
        <Title white>{processText(flavor.title).toLocaleUpperCase()}</Title>
      </Container>
      <ButtonWrapper>
        <SelectableLinkContainer
          stopKeyPress={showModal}
          handleKeyDown={onPressEscape}
          horizontal
        >
          <SelectableLink
            to="/desktop/PlayGame/WaitingRoom"
            onClick={playEnter}
          >
            {processText(flavor.playGame)}
          </SelectableLink>
          <SelectableLink to="/desktop/Rules">Rules</SelectableLink>
          <SelectableLink to="/desktop/Credit" onClick={playEnter}>
            {processText(flavor.credit)}
          </SelectableLink>
          <SelectableLink onClick={toggleModal}>
            {processText(flavor.exit)}
          </SelectableLink>
        </SelectableLinkContainer>
      </ButtonWrapper>
      {/* STEAL THiS FOR RESET? */}
      <Modal isOpen={showModal} close={toggleModal}>
        <SelectableLinkContainer
          stopKeyPress={!showModal}
          handleKeyDown={onPressEscape}
          inModal
        >
          <SelectableLink onClick={toggleModal} inModal>
            {processText(flavor.cancel)}
          </SelectableLink>
          <SelectableLink onClick={handleExit} inModal>
            {processText(flavor.exit)}
          </SelectableLink>
        </SelectableLinkContainer>
      </Modal>
    </>
  );
};

export default Home;
